












































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AlertBus } from "./AlertBus";
import { AlertEvent } from "./alert";

@Component({})
export default class AlertContainer extends Vue {
  show = false;
  resolve: Function;
  message = "";
  response = "false";
  type: string;
  messagesLength = 0;
  dontAskAgain: any[] = [];

  close() {
    this.show = false;
    this.resolve(false);
  }
  confirm() {
    this.show = false;
    const dontAskAgainSelected = this.dontAskAgain.filter(
      (el: any) => el.selected
    );
    dontAskAgainSelected.forEach((el: any) => {
      this.$cookies.set(el.message, true, "30d");
    });
    this.messagesLength = 0;
    this.dontAskAgain = [];
    this.resolve(true);
  }

  created() {
    AlertBus.$on(
      ["danger", "success", "confirm", "warn"],
      (par: AlertEvent) => {
        this.dontAskAgain = [];
        this.show = true;
        this.message = par.message;
        this.resolve = par.resolve;
        this.type = par.type;
        if (par.messageCookies) {
          this.messagesLength = par.messageCookies.messagesLength;
          par.messageCookies.dontAskAgain.forEach((el: string) => {
            this.dontAskAgain.push({
              message: el,
              selected: false
            });
          });
        }
      }
    );
  }
}
